var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5651 14.4971C38.4801 12.1265 37.5136 9.83741 36.0764 7.95001C34.6685 6.10143 32.7602 4.58077 30.535 3.91082C28.1715 3.19901 25.5192 3.50674 23.3811 4.74136C22.1092 5.47537 21.0309 6.53154 20.2472 7.77175C19.6664 6.57173 18.8284 5.49564 17.7917 4.65677C15.8721 3.10454 13.3002 2.38778 10.8543 2.7231C8.55175 3.03867 6.43062 4.2432 4.75184 5.85021C3.03831 7.49066 1.72708 9.6018 1.27407 11.9299C0.707059 14.8462 1.02341 18.1124 2.35079 20.77C3.75276 23.5771 6.18772 25.9462 8.74016 27.7699C13.0329 30.8369 18.6986 34.6999 18.6986 34.6999C18.6986 34.6999 24.0062 31.3432 28.7238 28.9817C31.5294 27.5774 34.3036 25.6166 36.1247 23.0625C37.8499 20.643 38.6712 17.4656 38.5651 14.4971Z",
    fill: "#E4DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group-4.5481ec91036b929fb0713934dc79b0ff.svg";
export { ForwardRef as ReactComponent };